import React from "react";
import { Nav, NavItem, Alert, Badge } from "bootstrap-micro";
import { Route, Redirect, Switch } from "react-router";


import { StatusTab } from "./tabs/StatusTab.jsx";
import { EventsTab } from "./tabs/EventsTab.jsx";
import { DevicesTab } from "./tabs/DevicesTab.jsx";
import { AboutTab } from "./tabs/AboutTab.jsx";

import { ZoneEditor } from "../editors/ZoneEditor.jsx";
import { ModuleTab } from "./tabs/ModuleTab.jsx";
import { ModuleEditor } from "../editors/ModuleEditor.jsx";
import { ModuleDeviceEditor } from "../editors/ModuleDeviceEditor.jsx";
import { useRouteMatch } from "react-router-dom";
import { useSiteConnected } from "../store/connectionSlice.js";
import { siteResetEventCount, usePanelEventCount } from "../store/sitesSlice.js";
import { useDispatch } from "react-redux";


export const MultiloopPanelManager = function(props) {

    const dispatch = useDispatch();

    const match = useRouteMatch();
    console.log({ match });
    const unreadEvents = usePanelEventCount(match.params.hwaddr, match.params.networkId);
    const isConnected = useSiteConnected(match.params.hwaddr);

    return <div>
        <div role="tabpanel" className="nav-center">
            <Nav bsStyle="tabs" activeHref={window.location.hash}>
                <NavItem className="nav-tabs__tab" href={`#${match.url}/status`}>Status</NavItem>
                <NavItem 
                    className="nav-tabs__tab" 
                    href={`#${match.url}/events`}
                    onClick={() => dispatch(siteResetEventCount(match.params.hwaddr, match.params.networkId)) } 
                >Events&nbsp;{unreadEvents > 0 ? <Badge>{unreadEvents}</Badge> : null}</NavItem>
                <Route path={`${match.path}/modules`}>
                    {({ match: pathMatch }) => <NavItem active={pathMatch != null}  className="nav-tabs__tab" href={`#${match.url}/modules`}>Modules</NavItem>}
                </Route>
                <Route path={`${match.path}/devices`}>
                    {({ match: pathMatch }) => <NavItem active={pathMatch != null} className="nav-tabs__tab" href={`#${match.url}/devices`}>Devices</NavItem>}
                </Route>
                <NavItem className="nav-tabs__tab" href={`#${match.url}/about`}>About</NavItem>
            </Nav>
        </div>
        <div className="container" style={{ paddingTop: "20px" }}>
            {!isConnected ?
                <Alert bsStyle="warning">
                    <h4>Your Panel Is Currently Only Receiving Events</h4>
                    <p>To control or edit your panel, on your panel go to Network Setup → Cloud and click enable.</p>
                </Alert> 
                : null}
            <Switch>
                <Route exact path={`${match.path}/status`} component={StatusTab} />
                <Route exact path={`${match.path}/events`} component={EventsTab} />

                {/* 
                    * TODO: Undisable slices once bug fixed
                    * <Route exact path={`${match.path}/slices`} component={DayNightEditor} /> 
                    */}

                <Route exact path={`${match.path}/modules`} component={ModuleTab} />
                <Route exact path={`${match.path}/modules/:portId`} component={ModuleEditor} />
                <Route exact path={`${match.path}/modules/:portId/device/:deviceId`} component={ModuleDeviceEditor} />

                <Route exact path={`${match.path}/devices`} component={DevicesTab} />
                <Route exact path={`${match.path}/devices/zone/:id`} component={ZoneEditor} />


                <Route exact path={`${match.path}/about`} component={AboutTab} />
                {/* <Route exact path={`${match.path}/settings`} component={SettingsTab} /> */}
                <Route exact render={() => <Redirect to={`${match.url}/status`} />} />
            </Switch>
        </div>
    </div>
}